import { createClientConfig } from "@repo/design-system/lib/client-registry";
import { Joblist } from "~/components/job-board/joblist-eon";
import FilterbarEonGridsolutions from "~/components/job-board/subclients/eon-gridsolutions/filterbar-eon-gridsolutions";
import TeaserBarEonGridsolutions from "~/components/job-board/subclients/eon-gridsolutions/teaserbar-eon-gridsolutions";
import { UnifiedJobPageTemplate } from "~/components/job-page/jobpagetemplate/unified-jobpage-template";
import FooterEonGridsolutions from "~/components/page-skeleton/subclients/eon-gridsolutions/footer-eon-gridsolutions";
import HeaderMainEonGridsolutions from "~/components/page-skeleton/subclients/eon-gridsolutions/header-main-eon-gridsolutions";
import { eonGridsolutionsDefault } from "./default";

export const eonGridsolutions = createClientConfig({
  components: {
    JobpageTemplate: UnifiedJobPageTemplate,
    Filterbar: FilterbarEonGridsolutions,
    Joblist,
    HeaderMain: HeaderMainEonGridsolutions,
    Footer: FooterEonGridsolutions,
    TeaserBar: TeaserBarEonGridsolutions,
  },
  ui: {
    searchSummaryEmpty: "Jobs bei E.ON Grid Solutions",
  },
  subtemplates: [eonGridsolutionsDefault],
});
